import { useState } from "react"
import { MdCancel } from "react-icons/md"
import { useTranslation } from "react-i18next"
import { colors } from "../../../utilities/colors"

export default function UploadUnitFile({ files, setFiles }) {
  const [imagePreviews, setImagePreviews] = useState([])
  const { t } = useTranslation()

  const handleFileUpload = (event) => {
    const newFiles = Array.from(event.target.files)
    const startIndex = files.length

    newFiles.forEach((file, i) => {
      const reader = new FileReader()
      reader.onloadend = () => {
        setImagePreviews((prev) => {
          const next = [...prev]
          next[startIndex + i] = reader.result
          return next
        })
      }
      reader.readAsDataURL(file)
    })

    setFiles((prev) => [...prev, ...newFiles])
  }

  const handleRemoveFile = (index) => {
    setFiles((prev) => prev.filter((_, i) => i !== index))
    setImagePreviews((prev) => prev.filter((_, i) => i !== index))
  }

  return (
    <div className="flex flex-col gap-2">
      <div className="flex items-center gap-2">
        <label className="text-sm text-grey-300">{t('Bill of Sale')}</label>
        <label>
          <span className="py-2 px-4 inline-block rounded border-2 border-grey-700 cursor-pointer" data-testid="choose-file">
            {files.length > 0 ? t('Choose More Files') : t('Choose File')}
          </span>
          <input type="file" className="sr-only" onChange={handleFileUpload} accept=".jpg, .jpeg, .png, .HEIC, .pdf" multiple />
        </label>
      </div>
      {files.length > 0 && (
        <div className="flex flex-wrap gap-2">
          {files.map((file, index) => (
            <div key={index} className="relative w-24 h-24">
              {file.type === 'application/pdf' ? (
                <div
                  data-testid="bos-preview"
                  className="w-full h-full flex items-center justify-center border border-gray-300 rounded bg-grey-900 text-grey-300 text-xs text-center p-1"
                >
                  {file.name}
                </div>
              ) : (
                <img
                  src={imagePreviews[index]}
                  alt="Preview"
                  data-testid="bos-preview"
                  className="w-full h-full object-cover border border-gray-300 rounded"
                />
              )}
              <MdCancel
                onClick={() => handleRemoveFile(index)}
                className="absolute top-0 right-0 w-5 h-5"
                color={colors.fpxRed}
                data-testid="md-cancel"
              />
            </div>
          ))}
        </div>
      )}
    </div>
  )
}